import { useState } from 'react';
import { Form, Input, Button, message, Card, Spin } from 'antd';
import { LockOutlined, UnlockOutlined } from '@ant-design/icons';
import appConstant from './../json/appConstant.json';
import useApis from "../apis/useApis";

const ChangePassword = ({ isDarkMode }) => {
  const { jsonApi } = useApis();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);

    // Call the API to change the password
    const response = await jsonApi(
      appConstant.changePassword,
      null,
      values,
      null,
    );

    if (response.data) {
      message.success("Password changed successfully");
      setLoading(false);
    } else {
      message.error(response.message || 'An error occurred');
      setLoading(false);
    }
  }

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <h2 style={{ margin: 0, color: isDarkMode ? '#ffffff' : undefined }}>Change Password</h2>
      </div>
      <Card
        style={{
          background: isDarkMode ? '#1f1f1f' : '#ffffff',
          borderColor: isDarkMode ? '#303030' : '#f0f0f0',
        }}
      >
        {loading ? (
          <Spin
            size="large"
            style={{ display: 'block', textAlign: 'center', marginTop: '50px' }}
          />
        ) : (
          <Form
            name="change-password"
            onFinish={handleSubmit}
            layout="vertical"
            initialValues={{
              currentPassword: '',
              password: '',
              confirmPassword: '',
            }}
          >
            <Form.Item
              label="Current Password"
              name="currentPassword"
              rules={[
                {
                  required: true,
                  message: 'Please input your current password',
                },
              ]}
            >
              <Input.Password prefix={<LockOutlined />} style={{ width: '500px' }} maxLength={20} />
            </Form.Item>

            <Form.Item
              label="New Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input your new password',
                },
                {
                  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                  message: 'Password must include uppercase, lowercase, number, and special character.',
                },
              ]}
            >
              <Input.Password prefix={<UnlockOutlined />} style={{ width: '500px' }} maxLength={20} />
            </Form.Item>

            <Form.Item
              label="Confirm New Password"
              name="confirmPassword"
              dependencies={['password']}
              rules={[
                {
                  required: true,
                  message: 'Please confirm your new password',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Password and Confirm Password do not match'));
                  },
                }),
              ]}
            >
              <Input.Password prefix={<UnlockOutlined />} style={{ width: '500px' }} maxLength={20} />
            </Form.Item>

            <Form.Item>
              <Button

              
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                Change Password
              </Button>
            </Form.Item>
          </Form>
        )}
      </Card>
    </div>
  );
};

export default ChangePassword;
